<template>
  <div class="wrapper">
    <div class="container details">
      <div class="row"><div class="col-md-10"><h1>Daglig tillsyn</h1></div></div>
      <div class="row" style="margin-top: 30px;width:1170px;max-width:100%">
        <div class="col-md-2">
          <label for="startDate">Från</label><br/>
          <Calendar id="startDate" v-model="startDate" :locale="sv" dateFormat="yy-mm-dd" :manualInput="false" />
        </div>
        <div class="col-md-2">
          <label for="endDate">Till</label><br/>
          <Calendar id="endDate" v-model="endDate" :locale="sv" dateFormat="yy-mm-dd" :manualInput="false" />
        </div>
        <div class="col-md-2">
          <label for="drivers">Chaufför</label><br/>
          <Dropdown v-if="drivers" v-model="selectedDriver" :options="drivers" style="width:100%" optionLabel="name" placeholder="Välj chaufför.." />
        </div>
        <div class="col-md-2">
          <label for="customers">Fordon</label><br/>
          <Dropdown v-if="trucks" v-model="selectedTruck" :options="trucks" style="width:100%" optionLabel="name" placeholder="Välj fordon.." />
        </div>
        <div class="col-md-1">
          <br/>
          <Button label="Sök" @click="getItems()"></Button>
        </div>
        <div class="col-md-1">
            <ProgressSpinner v-if="loading" style="width:50px;height:50px" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s" />
        </div>
      </div>
      <div class="row mt-4" v-if="items">
        <div class="col-md-12">
            <DataTable v-if="items" :value="items" dataKey="id">
                <Column field="createdAt" header="Datum" :sortable="true" :headerStyle="{'width': '10em'}">
                  <template #body="slotProps" >{{getDate(slotProps.data.createdAt)}}</template>
                </Column>
                <Column field="driver" header="Chaufför" :sortable="true"></Column>
                <Column field="truck" header="Lastbil" :sortable="true"></Column>
                <Column field="comment" header="Kommentar"></Column>
                <Column field="showComment" header="Visa kommentar" headerStyle="width:10rem" bodyStyle="text-align:center" :sortable="true">
                  <template #body="slotProps">
                    <Checkbox v-model="slotProps.data.showComment" :binary="true" />
                  </template>
                </Column>
                <Column headerStyle="width:5rem" bodyStyle="text-align:center">
                  <template #body="slotProps" >
                    <Button class="p-button" title="Spara" @click="onSave(slotProps.data)" icon="pi pi-save" ></Button>
                  </template>
                </Column>
                <Column headerStyle="width:5rem" bodyStyle="text-align:center">
                  <template #body="slotProps" >
                    <Button class="p-button-danger" title="Ta bort" @click="onArchive(slotProps.data)" icon="pi pi-trash" ></Button>
                  </template>
                </Column>
            </DataTable>
        </div>
      </div>
    </div>
    <Toast position="bottomright" />
  </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from 'primevue/dialog'
import Row from 'primevue/row'
import ColumnGroup from 'primevue/columngroup'
import Button from 'primevue/button'
import moment from 'moment'
import Checkbox from 'primevue/checkbox'
import Calendar from 'primevue/calendar'
import Toast from 'primevue/toast'
import Dropdown from 'primevue/dropdown'
import ProgressSpinner from 'primevue/progressspinner'
export default {
  name: 'DailyCheckup',
  components: {
    DataTable,
    'Toast': Toast,
    Column,
    Button,
    moment,
    ColumnGroup,
    Checkbox,
    Dialog,
    Calendar,
    Row,
    ProgressSpinner,
    Dropdown
  },
  data () {
    return {
      startDate: null,
      endDate: null,
      selectedDriver: null,
      selectedTruck: null,
      selectedItemToArchive: null,
      trucks: [],
      drivers: [],
      displayModalArchive: false,
      items: [],
      loading: false,
      sv: {
        firstDayOfWeek: 1,
        dayNames: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
        dayNamesShort: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
        dayNamesMin: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
        monthNames: [ 'Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December' ],
        monthNamesShort: [ 'Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec' ],
        today: 'Idag',
        clear: 'Rensa',
        dateFormat: 'yy-mm-dd',
        weekHeader: 'vk'
      }
    }
  },
  async mounted () {
    this.setMonth()
    await this.getDrivers()
    await this.getTrucks()
    await this.getItems()
  },
  watch: {
    items: function (newVal, oldVal) {
      this.items = newVal
    }
  },
  methods: {
    async getDrivers () {
      this.$http
        .get('api/users')
        .then(response => {
          let drivers = response.data
          this.drivers.push({id: null, name: 'Alla'})
          for (var i = 0; i < drivers.length; i++) {
            if (drivers[i].inActive !== 'Ja') {
              this.drivers.push({'id': drivers[i].id, 'name': drivers[i].firstName + ' ' + drivers[i].lastName})
            }
          }
        })
        .catch(error => console.log(error))
    },
    async getTrucks () {
      this.$http
        .get('/api/objectdatas/objectgroupid/2')
        .then(response => {
          let trucks = response.data
          this.trucks.push({id: null, name: 'Alla'})
          trucks.sort(this.sortByName)
          for (var i = 0; i < trucks.length; i++) {
            this.trucks.push({'id': trucks[i].id, 'name': trucks[i].data.regnbr})
          }
        })
        .catch(error => console.log(error))
    },
    async getItems () {
      this.loading = true
      let startDate = moment(this.startDate).format('YYYY-MM-DD')
      let endDate = moment(this.endDate).format('YYYY-MM-DD')
      let driverId = null
      let truckId = null
      if (this.selectedDriver) {
        driverId = this.selectedDriver.id
      }
      if (this.selectedTruck) {
        truckId = this.selectedTruck.id
      }
      let callApi = '/api/appLog/bytype/dailyCheckup/byuser/' + driverId + '/bytruck/' + truckId + '/by-daterange/between/' + startDate + '/' + endDate
      await this.$http
        .get(callApi)
        .then(response => {
          this.items = []
          for (var i = 0; i < response.data.length; i++) {
            if (response.data[i].data.archived === false) {
              let driver = this.drivers.find(x => x.id === response.data[i].userId)
              let truck = this.trucks.find(x => x.id === response.data[i].truckId)
              if (driver && truck) {
                let comment = ''
                let showComment = false
                if (response.data[i].comment !== undefined) {
                  comment = response.data[i].comment[0].text
                  showComment = response.data[i].comment[0].showComment
                }
                this.items.push({id: response.data[i].id, driver: driver.name, truck: truck.name, comment: comment, showComment: showComment, createdAt: response.data[i].createdAt, data: response.data[i].data})
              }
            }
          }
          this.loading = false
        })
    },
    sortByName (a, b) {
      return a.data.regnbr.localeCompare(b.data.regnbr)
    },
    setMonth () {
      let today = new Date()
      this.endDate = new Date()
      let oneMonthBack = new Date(today.setDate(today.getDate()))
      this.startDate = oneMonthBack
    },
    getDate (theDate) {
      let formattedDate = moment(theDate).format('YYYY-MM-DD HH:mm')
      return formattedDate
    },
    onSave (data) {
      let message = 'Vill du spara dina ändringar?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          let url = '/api/appLog/' + data.id
          this.$http
            .put(url, {appLog: data})
            .then(response => {
              this.$toast.add({severity: 'success', summary: 'Sparad', life: 3000})
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    },
    onArchive (data) {
      let message = 'Vill du ta bort?'
      let options = {
        okText: 'Fortsätt',
        cancelText: 'Stäng'
      }
      this.$dialog.confirm(message, options)
        .then(dialog => {
          let url = '/api/appLog/' + data.id
          data.data.archived = true
          this.$http
            .put(url, {appLog: data})
            .then(response => {
              this.$toast.add({severity: 'success', summary: 'Borttagen', life: 3000})
              this.getItems()
            })
            .catch(error => console.log(error))
        })
        .catch(function () {
          console.log('Clicked on cancel')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Statistics/DailyCheckup.vue